export interface PotentialHitPricePillProps {
  /** Pre-formatted price string без $-префикса; компонент сам добавит "~$". */
  price: string;
}

/**
 * PotentialHitPricePill — белая капсула с ценой "~$<price>",
 * абсолютно позиционируется внутри карточки PotentialHitItem
 * (caller отвечает за relative-parent).
 *
 * Выделено из modules/potentialHits/PotentialHitItem.tsx.
 */
export function PotentialHitPricePill({ price }: PotentialHitPricePillProps) {
  return (
    <div
      data-co-component="PotentialHitPricePill"
      className="
        absolute bottom-[10px] left-1/2 -translate-x-1/2
        flex items-center justify-center whitespace-nowrap
        [border-radius:var(--co-PotentialHitPricePill-borderRadius,9999px)] bg-[color:var(--co-PotentialHitPricePill-fill,#fff)] px-[8px] py-[4px]
        shadow-[0_1px_2px_0_rgba(25,25,25,0.1)]
      "
    >
      <span className="type-subhead text-[color:var(--co-PotentialHitPricePill-text,#15181e)]">~${price}</span>
    </div>
  );
}
